import _ from 'lodash';
import Backbone from 'backbone';

import './CollapsibleView.css';
import {LocalStorageUtil} from 'util/LocalStorageUtil';
import {getCurrentUserIdLong} from 'module/SessionInfo/api/SessionInfoAPI';

export const CollapsibleView = Backbone.View.extend({
	className: 'CollapsibleView',
	events: {
		'click .CollapsibleToggleRegion': 'toggleCollapse',
	},
	persistedViewStateProps: ['collapsed'],
	/**
	 * @param options
	 * @param {String} options.name for persisting status in local storage (prepend app name if you want per app storage)
	 * @param {Integer} options.collapsedHeight height in px of collapsed content
	 * @param {Backbone.View | [Backbone.View]} options.views content to wrap in collapsibleView - first 1em row is toggle
	 * @param {String} [options.collapsed] initial status
	 */
	initialize: function (options) {
		this.viewState = new Backbone.Model({
			// -- persisted user setting --
			collapsed: options && options.collapsed === true,
			// -- NOT persisted --
			collapsedHeight: options.collapsedHeight || 10,
		});
		this.viewStateDefaults = this.viewState.pick(this.persistedViewStateProps);
		this.name = options && options.name;
		this.views = options.views;
		if (!_.isArray(this.views)) this.views = [this.views];
		this.loadSettings();
		this.listenTo(this.viewState, 'change', this.saveSettings);
		_.each(this.views, (view) => {
			this.listenTo(view, 'toggleCollapse', this.toggleCollapse);
		});
		this.render();
		this.listenTo(this.viewState, 'change', this.refreshCollapsed);
		this.refreshCollapsed();
	},
	getStorageId: function () {
		return [
			getCurrentUserIdLong(),
			'CollapsibleView',
			this.name,
		].join('_');
	},
	applyDefaultSettings() {
		this.viewState.set(this.viewStateDefaults);
	},
	saveSettings: function () {
		if (!localStorage) return;
		LocalStorageUtil.save(this.getStorageId(), this.viewState.pick(this.persistedViewStateProps));
	},
	loadSettings: function () {
		var store = LocalStorageUtil.load(this.getStorageId());
		this.viewState.set(store);
	},
	resetSettings: function () {
		this.applyDefaultSettings();
		LocalStorageUtil.remove(this.getStorageId());
	},
	toggleCollapse: function () {
		this.viewState.set({
			collapsed: !this.viewState.get('collapsed'),
		});
		return false;
	},
	refreshCollapsed: function () {
		var collapsed = !!this.viewState.get('collapsed');
		this.$el.toggleClass('collapsed', collapsed);
		var collapsedHeight = this.viewState.get('collapsedHeight');
		if (collapsed) this.$c.content.height(collapsedHeight);
		else this.$c.content.height('auto');
		this.$c.status.css({
			height: collapsedHeight,
			lineHeight: collapsedHeight + 'px',
		});
		this.$c.region.css({
			height: collapsedHeight,
		});
	},
	remove: function () {
		_.each(this.views, function (v) {
			v.remove();
		});
		Backbone.View.prototype.remove.call(this);
	},
	template: _.template('<div class="CollapsibleToggleRegion CollapsibleViewButton MenuButton">\n\t<i class="CollapsibleViewStatus fa fa-caret-down"></i>\n</div>\n<div class="CollapsibleViewContent"></div>'),
	render: function () {
		this.$el.html(this.template());
		var $c = this.$c = {
			content: this.$('.CollapsibleViewContent'),
			region: this.$('.CollapsibleToggleRegion'),
			status: this.$('i.CollapsibleViewStatus'),
		};
		_.each(this.views, function (v) {
			$c.content.append(v.el)
		});
	},
});

export default CollapsibleView;